import axios from "axios";
import useDecryptData from "../utils/DecryptData";
import { getPublicO2WAuthToken, isPublicO2WPath } from "./commonData";

export function GetDecryptToken() {
  const DecryptData = useDecryptData();
  let EncryptToken = localStorage.getItem("token");
  let finalToken = DecryptData(EncryptToken);
  return finalToken;
}

export function GetRequestAuthToken() {
  if (isPublicO2WPath()) {
    return getPublicO2WAuthToken();
  }
  return GetDecryptToken();
}

///API Base Url
const baseUrl = window.location.hostname.includes("knackgalaxy")
  ? process.env.REACT_APP_API_PROD_URL
  : process.env.REACT_APP_API_DEV_URL;

export const httpCommon = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const httpTokenCommon = axios.create({
  baseURL: baseUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});
export const httpTokenFileDownload = axios.create({
  baseURL: baseUrl,
  responseType: "blob",
});

httpTokenCommon.interceptors.request.use(
  (config) => {
    const token = GetRequestAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpTokenCommon.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      if (!isPublicO2WPath()) {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

httpTokenFileDownload.interceptors.request.use(
  (config) => {
    const token = GetRequestAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
